export default {
  'meta': {
    'langName': 'PORTUGUÊS',
    'lang': 'Português'
  },
  'title': 'RECOLHA DE PRODUTO TABELA DE BASQUETE HOOP B900 BOX NBA TARMAK',
  'description': 'Bom dia,\n\nComprou recentemente uma tabela de basquetebol Tarmak B900 BOX NBA e agradecemos-lhe a preferência.\n\nNo âmbito do nosso compromisso permanente com a qualidade e a segurança dos produtos, a equipa da DECATHLON Basquetebol identificou um risco possível de queda vertical do poste se a manivela de regulação da altura for retirada e o produto for manuseado ou utilizado.\n\nPedimos-lhe que responda a algumas perguntas para podermos fornecer-lhe a solução de segurança adequada para o seu produto.\n\nPedimos desculpa pelo incómodo e agradecemos a sua confiança.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Em primeiro lugar, agradecemos que confirme o seu endereço de e-mail e o país de residência:'
  },
  'fields': {
    'country': 'País',
    'address': 'Endereço de e-mail',
    'email': 'Endereço de e-mail',
    'phonePrefix': 'Indicativo de número de telefone',
    'phone': 'Número de telefone',
    'validations': {
      'phoneOrEmail': 'Agradecemos que nos indique pelo menos um endereço de e-mail OU um número de telefone',
      'email': 'Queira indicar um endereço de e-mail válido',
      'phone': 'Queira indicar um número de telefone válido'
    },
    'firstName': 'Nome',
    'lastName': 'Apelido',
    'deliveryAddress': 'Endereço para entrega',
    'additionalAddress': 'Endereço para entrega (cont.)',
    'city': 'Cidade',
    'zip': 'Código postal',
    'choose': 'Escolher',
    'required': 'Este campo é obrigatório'
  },
  'ownerCheck': {
    'title': 'Ainda é proprietário de uma ou mais tabelas de basquetebol B900 BOX NBA?'
  },
  'yes': 'SIM',
  'no': 'NÃO',
  'ownerChanged': {
    'title': 'Tem o contacto dos proprietários atuais?',
    'confirmation': 'Caro Sr./Sra.,\n\nObrigado por participar nesta iniciativa de qualidade.\n\nPedimos desculpa pelo incómodo e agradecemos a sua confiança.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Queira indicar-nos o número de tabelas de basquetebol que possui, com base no tipo de manivela instalada',
    'descriptionRed': 'Tabela de basquetebol com manivela vermelha amovível',
    'descriptionBlack': 'Tabela de basquetebol com manivela preta fixa',
    'quantity': 'Quantidade',
    'notConcerned': 'Caro Sr./Sra.,\n\nObrigado por participar nesta iniciativa de qualidade.\n\nPode ficar descansado/a, a sua tabela de basquetebol Tarmak B900 BOX NBA não é afetada pelo processo de recolha. A sua utilização é segura.\n\nPedimos desculpa pelo incómodo e agradecemos a sua confiança.\n\nDECATHLON',
    'concernedProductQuantity': 'Quantidade de produto não conforme:',
    'concernedProductLabel': 'Produto não conforme:',
    'confirmation': 'Obrigado por preencher este formulário. O seu pedido foi registado com sucesso.\n\nEnviar-lhe-emos o número de seguimento da entrega do seu conjunto o mais rapidamente possível (via FandiWeb para os países europeus/via X para os países não europeus).\n\nDesejamos-lhe um ótimo dia.\n\nDECATHLON'
  },
  'repair': {
    'title': 'Reparação com a sua participação',
    'description': 'Detetámos um risco de queda vertical do poste se a manivela for retirada e o produto for manuseado ou utilizado em determinadas tabelas de basquetebol TARMAK B900 BOX NBA, ref.ª 4239136.\nCom base na sua resposta, o seu produto parece estar afetado por este risco.\n\nPor conseguinte, pedimos-lhe que deixe de o utilizar imediatamente e propomo-nos ajudá-lo/a a adaptar a manivela para que possa utilizar o seu produto em segurança.\nPode ter a certeza de que esta reparação não requer conhecimentos especiais - tudo está claramente explicado no vídeo e nas instruções abaixo:',
    'videoLink': 'Ligação vídeo',
    'docLink': 'Ligação instruções',
    'callToAction': 'Clicar aqui para receber gratuitamente o seu conjunto de reparação ',
    'warranty': 'Todo o processo está coberto pela nossa garantia de 5 anos'
  },
  'repairRequest': {
    'title': 'Queira inserir as informações seguintes para que o conjunto gratuito de reparação seja enviado para o endereço que escolher:'
  },
  'form': {
    'submit': 'Seguinte'
  },
  'status': 'Translation validated by COUNTRY'
} as const
